@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="small-variant">
        <app-ice-visuals-dashboard-bar-chart
            [variant]="barChartVariantEnum.STACKED"
            [rowGap]="36"
            [columns]="stackedVariantColumns()"
            [rows]="stackedVariantRows()"
            [maxValue]="100"
            [skeletonRowCount]="2"
            [loading]="dataService.loading()"
        />
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    @if (!showAnyTableColumn()) {
        <div class="large-variant-no-data">
            <span>{{ 'dashboard.visuals.widgets.distribution.noDataSelected' | translate }}</span>
        </div>
    } @else if (showAnyTableColumn() && distributorIdsToShow()?.length === 0) {
        <div class="large-variant-no-data">
            <span>{{ 'dashboard.visuals.widgets.distribution.noDistributorsSelected' | translate }}</span>
        </div>
    } @else {
        <div class="large-variant">
            <app-ice-visuals-dashboard-bar-chart
                [maxValue]="100"
                [rowGap]="12"
                [columns]="tableVariantColumns()"
                [rows]="tableVariantRows()"
                [loading]="dataService.loading()"
            />
        </div>
    }
}
